export const DROPBOX_APP_KEY = 'fihrvby9dg9jwdd';

export const ONEDRIVE_APP_ID = 'ac53fd03-3950-4189-a142-4b78fa549235';
export const ONEDRIVE_AUTHORITY = 'common';

export const GOOGLE_DRIVE_API_KEY = 'AIzaSyDNE0A3KZEinnvlsYZAZJau6KcDKy7hGIA';
export const GOOGLE_DRIVE_CLIENT_ID =
  '783431336947-g2dlc750s1kot83ot5nia3to6vrqsn0c.apps.googleusercontent.com';
export const GOOGLE_DRIVE_APP_ID = '783431336947';
